import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';
import { DRBFMAnalysisProgress } from '../../../../types';
import { flowConfigs } from './flowConfigs';
import { FlowStatusBadge, FlowStatusIcon } from './FlowStatusIndicators';

interface FlowProgressListProps {
  flowStatuses: DRBFMAnalysisProgress['flowStatuses'];
  currentFlow: number;
}

const FlowProgressList: React.FC<FlowProgressListProps> = ({ flowStatuses, currentFlow }) => {
  const { t } = useTranslation();

  return (
    <Card className="mb-6">
      <CardContent className="p-4 pb-6">
        <p className="revy-cjk mb-2 text-base leading-[1.75]">
          {t('drbfm.processing.flowStatus')}
        </p>
        <Separator className="mb-4" />
        <ul>
          {flowConfigs.map((flow, index) => (
            <li
              key={flow.id}
              className={cn(
                'flex items-center rounded px-4 py-2',
                currentFlow === flow.id && 'bg-accent',
                index < flowConfigs.length - 1 && 'mb-2',
              )}
            >
              <div className="min-w-14 shrink-0">
                <FlowStatusIcon status={flowStatuses[flow.key]} />
              </div>
              <div className="min-w-0 flex-1">
                <span className="flex items-center gap-2 text-sm font-medium">
                  {flow.icon}
                  <span className="revy-cjk leading-[1.5]">
                    {t('drbfm.processing.flowLabel', {
                      id: flow.id,
                      label: t(flow.labelKey),
                    })}
                  </span>
                </span>
                <p className="revy-cjk text-sm leading-[1.5] text-muted-foreground">
                  {t(flow.descriptionKey)}
                </p>
              </div>
              <FlowStatusBadge status={flowStatuses[flow.key]} />
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};

export default FlowProgressList;
